import { render } from "./BaseCardWhite.vue?vue&type=template&id=20adebb5&scoped=true"
const script = {}

import "./BaseCardWhite.vue?vue&type=style&index=0&id=20adebb5&lang=scss&scoped=true"

import exportComponent from "/Users/josiahsprankle/Desktop/personal/JDS-Music-Site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20adebb5"]])

export default __exports__